module.exports = __webpack_public_path__ + "dimer/static/img/5.90ede3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/5.jpg
// module id = HQDL
// module chunks = 0